/** @file Focus store: the one entity the Inspector shows besides the selection (an image, IK, event…). */
import { createStore } from 'zustand/vanilla';
import type { EntityKind, Id } from '@pose2d/format/types';
import { selectionStore } from './selectionStore';

/** An entity to inspect. */
export interface InspectorFocus {
  kind: EntityKind;
  id: Id;
}

/** Vanilla store; cleared by every selection change, so set the selection first and the focus after it. */
export const focusStore = createStore<{ focus: InspectorFocus | null }>()(() => ({ focus: null }));

selectionStore.subscribe(() => { focusStore.setState({ focus: null }); });
